import {h} from "preact";

export const CfgmRequirements = ({id}) =><div className=" margin-auto" id={id}>
        <div className="innerText">
            <p>Para matricularte al ciclo de Grado Medio, debes tener <strong>más de 18 años o cumplirlos durante el año natural del comienzo del ciclo</strong>.
            Además, tienes que cumplir al menos uno de los siguientes requisitos académicos:</p>
        </div>
        <ul>
            <li>Tener el título de Graduado en Educación Secundaria Obligatoria (ESO).</li>
            <li>Tener el Graduado en Educación Secundaria (GES).</li>
            <li>Tener el título de Técnico/a o de Técnico/a auxiliar.</li>
            <li>Haber superado el segundo curso del Bachillerato Unificado y Polivalente (BUP).</li>
            <li>Si no se ha superado el Bachillerato Unificado y Polivalente (BUP), tener un máximo de dos materias pendientes en el conjunto de los dos cursos.</li>
            <li>Tener el título de Bachiller.</li>
            <li>Haber superado la Prueba de Acceso a la Universidad para mayores de 25 años.</li>
            <li>Haber superado la prueba o el curso específico para el acceso a los ciclos formativos de Grado Medio o Grado Superior.</li>
            <li>Haber superado los módulos obligatorios de un programa de cualificación profesional inicial (PCPI).</li>
            <li>Tener un título de Grado Medio o de Grado Superior de cualquier ciclo formativo. </li>
            <li>Tener un título para acceder a un ciclo formativo de Grado Superior.</li>
            <li>Tener otros estudios equivalentes a efectos académicos.</li>
        </ul>
        <div className="warning-text">
          <h2 class="m-bottom">¿Has estudiado en el extranjero?</h2>
          <p>Si este es tu caso, debes presentar la homologación o convalidación de tu título para que tu matrícula y tus notas sean válidas.</p>
          <h2 class="m-bottom m-top">¿Qué documento debes subir?</h2>
          <ul class="list">
            <li>Si ya tienes la aprobación: Sube la resolución favorable.</li>
            <li>Si aún está en trámite: Sube tu volante de inscripción condicional (el resguardo de haberlo solicitado). Este resguardo debe estar <strong>debidamente sellado por el organismo oficial.</strong> Si el documento no tiene el sello oficial, no será válido y no podrás tener acceso para iniciar el curso.</li>
          </ul>
          <p class="m-top">Nota: <strong>Tu matrícula será provisional</strong> hasta que recibas el documento definitivo y nos lo envíes. <strong>Si la homologación es denegada o no se presenta, la matrícula y las notas obtenidas perderán su validez.</strong></p>
        </div>
        <div className="innerText">
            <p><strong>No permiten el acceso</strong> al ciclo de Grado Medio los siguientes documentos:</p>
        </div>
        <ul>
            <li>Tener un certificado de profesionalidad.</li>
            <li>Tener el título de Graduado Escolar (EGB).</li>
            <li>Tener el título de Bachillerato elemental.</li>
        </ul>
    </div>;
